import { FC } from "react";
import { useLogOutPageLogic } from "@/pages/log-out/utils";

export const LogOutPage: FC = () => {
  useLogOutPageLogic();

  return null;
};
